import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEraser = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.9499 21.05L2.6499 16.75C1.6499 15.75 1.6499 14.25 2.6499 13.35L12.2499 3.75C13.2499 2.75 14.7499 2.75 15.6499 3.75L21.2499 9.35C22.2499 10.35 22.2499 11.85 21.2499 12.75L12.9499 21.05",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 21.05H7",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 11.0229L14 20.0417",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgEraser;
